module.exports = __webpack_public_path__ + "images/mail.90fa720c038a88563e3a29d103da3995.svg";